import React from "react";
import styled from "styled-components";
import TitleSvg from "../img/title-speakers.svg";
import Speaker from "./Speaker";
import device from "../helpers/device";
import moreSvg from "../img/andmore.svg";

const speakers = [
  {
    name: "山口 光太",
    division: "アドテク本部",
    photo: "/img/speakers/A14824.png"
  },
  {
    name: "井上 辰徳",
    division: "メディア統括本部",
    photo: "/img/speakers/A12458.png"
  },
  {
    name: "石原 裕之",
    division: "株式会社サムザップ",
    photo: "/img/speakers/A13744.png"
  },
  {
    name: "佐藤 太志",
    division: "株式会社Cygames",
    photo: "/img/speakers/CF0016.png"
  },
  {
    name: "杉野 登志夫",
    division: "SGE統括本部",
    photo: "/img/speakers/A12066.png"
  },
  {
    name: "西村 遊",
    division: "株式会社アプリボット",
    photo: "/img/speakers/CJ0069.png"
  },
  {
    name: "鳥越 貴智",
    division: "アドテク本部",
    photo: "/img/speakers/A14345.png"
  },
  {
    name: "桐島 ローランド",
    division: "株式会社AVATTA",
    photo: "/img/speakers/S02297.png"
  },
  {
    name: "Gunther Brunner",
    division: "技術本部",
    photo: "/img/speakers/A12907.png"
  },
  {
    name: "山田 明憲",
    division: "技術本部",
    photo: "/img/speakers/A13062.png"
  }
];

export default function Speakers() {
  return (
    <Wrapper>
      <Title>
        <img src={TitleSvg} alt="SPEAKERS" />
      </Title>
      <Row>
        <Speaker
          head="開会の挨拶"
          division="代表取締役社長"
          name="藤田 晋"
          photo="/img/img1.png"
          size="L"
        />
      </Row>
      <Row>
        <Speaker
          head="基調講演"
          division="取締役"
          name="長瀬 慶重"
          photo="/img/img2.png"
          title="「技術政策 2019」"
          summary="2018年に「技術のサイバーエージェントを加速させる」をミッションに発足した技術政策室。<br />これまでの活動と今後の展望についてお話します。"
          size="L"
        />
      </Row>
      <Row2>
        {speakers.map(({ division, name, photo }) => (
          <Speaker
            className="speaker"
            key={name}
            division={division}
            name={name}
            photo={photo}
            size="M"
          />
        ))}
        <More>
          <img src={moreSvg} alt="and more" />
        </More>
      </Row2>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: 60px;
  @media ${device.mobileL} {
    padding-top: 100px;
  }
`;

const Title = styled.h2`
  text-align: center;
  margin: 0 auto;
  width: ${181 * 0.9}px;
  @media ${device.mobileL} {
    width: 181px;
    margin: 0 auto 70px auto;
  }
  > img {
    width: 100%;
  }
`;

const Row = styled.div`
  margin-top: 35px;
  @media ${device.mobileL} {
    margin-top: 70px;
  }
`;

const Row2 = styled.div`
  margin: 25px auto 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .speaker {
    text-align: center;
    padding: 20px;
  }
  @media ${device.mobileL} {
    margin: 50px auto 0 auto;
    display: grid;
    grid-template-columns: 172.5px 1fr 1fr 172.5px;
    width: 750px;
    .speaker {
      text-align: center;
      padding: 20px;
    }
  }
`;

const More = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  img {
    width: 100%;
    max-width: 200px;
  }
`;
